<mat-form-field class="w-100 mat-form-field {{_invalidClass}}">
 <input required placeholder={{placeholder}} matInput autocomplete="off"
 autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
 (click)="setTouched()" (keyup)="setTouched()"
 (setErrorState)="true"  #customMapLocation>
</mat-form-field>
